import React, { useEffect, useMemo, useState } from 'react'
import BreadCrumb from '../../../components/common/BreadCrumb';
import { Card, CardBody, CardHeader, Col, Row, Button } from 'react-bootstrap';
import { TableResponsive } from '../../../components/common/TableResponsive';
import { useDispatch } from 'react-redux';
import { followup, ASSET_URL } from '../../../helper/api_url';
import { swal } from '../../../helper/swal';
import { ViewFollowModal } from './ViewFollowModal';
import { FollowUpBtn } from './FollowUpBtn';
import { FollowUpHistoryModal } from './FollowUpHistoryModal';
import { isDate1BeforeOrEqual, formatDate } from '../../../helper/formatDate';
import ImageViewer from '../../../components/ImageViewer';
import { useQuery } from '@tanstack/react-query';
const FollowUp = () => {
    const dispatch = useDispatch();
    let currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const day = currentDate.getDate().toString().padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`
    const [selectedDate, setSelectedDate] = useState(formattedDate);
    const { data: followups = [], isLoading, isError, error } = useQuery({
        queryKey: ['followups', selectedDate],
        queryFn: () => followup.pending(selectedDate),
        staleTime: 20 * 60 * 1000, // 20 minutes
        cacheTime: 20 * 60 * 1000, // 20 minutes
        select: (data) => data?.data?.followup,
    });
    useEffect(() => { if (isError && error) { swal.error(error.response?.data.message || error.message); } }, [isError, error]);
    useEffect(() => { if (isError) swal.error(error.response ? error.response.data.message : error.message) }, [isError, error])
    const columns = useMemo(() => [
        {
            Header: "School Name",
            accessor: "name",
            HeaderClass: '',
            DataClass: '',
            Cell: (cell) => {
                const row = cell.row.original;
                const trial_end = row.enquiry.tryal_date != null ? new Date(row.enquiry.tryal_date) : null;
                if (trial_end != null) trial_end.setDate(trial_end.getDate() + row.enquiry.tryal_period);
                const imageUrl = ASSET_URL + row.enquiry.avatar;
                return (
                    <ImageViewer image={imageUrl}>

                        <span> <img style={{ objectFit: 'cover' }} className="me-2 rounded-circle header-profile-user" src={imageUrl} alt="User Avatar" />
                            {row.enquiry.name}
                            {(trial_end != null)
                                ? (trial_end > Date.now()
                                    ? (<span className='badge badge-soft-success px-1 ms-1'>On Trail</span>)
                                    : (<span className='badge badge-soft-danger px-1 ms-1'>Trail Expired</span>))
                                : null}
                        </span>
                    </ImageViewer>
                )
            }
        },
        { Header: 'Prefer Services', accessor: 'enquiry.course.name' },
        { Header: 'Phone', accessor: 'enquiry.phone' },
        {
            Header: "Follow By",
            Cell: (cell) => {
                const row = cell.row.original;
                return (<span>{row.enquiry?.created_by?.first_name} {row.enquiry?.created_by?.last_name}</span>)
            }
        },
        {
            Header: "Status",
            HeaderClass: 'text-center',
            DataClass: 'text-center',
            Cell: (cell) => {
                const row = cell.row.original;
                return (<><span className='badge badge-soft-warning px-1 ms-1'>{row.status}...</span><br />{formatDate(row.joining_date)}</>)
            }
        },
        {
            Header: "Action",
            HeaderClass: 'text-center',
            DataClass: 'text-center',
            Cell: (cell) => {
                const row = cell.row.original;
                return (
                    <div className="d-flex align-items-center justify-content-center gap-1">
                        <ViewFollowModal follow={row} />
                        <FollowUpHistoryModal enquiryId={row.enquiry.id} schoolName={row.enquiry.name}>
                            <button className="btn btn-sm btn-soft-primary" title="SMS History">
                                <i className="ri-chat-3-line" />
                            </button>
                        </FollowUpHistoryModal>
                        {(isDate1BeforeOrEqual(formattedDate, row.joining_date))
                            ? <FollowUpBtn follow={row} onSuccess={res => {
                                const updatedFollowups = followups.filter(i => i.id !== row.original.id);
                                const joiningDate = new Date(res.joining_date);
                                if (joiningDate <= new Date()) {
                                    updatedFollowups.unshift(res);
                                }
                            }} />
                            : <span className='btn btn-sm btn-soft-warning add-btn waves-effect align-bottom me-1'>PostPond</span>}
                    </div>
                )
            },
        },
        {
            Header: 'List',
            HeaderClass: 'd-none',
            DataClass: 'd-none',
            listClass: 'list-group-item border-0 px-0 bg-transparent',
            list: (followup) => {
                const row = followup;
                const imageUrl = ASSET_URL + row.enquiry.avatar;
                const trial_end = row.enquiry.tryal_date != null ? new Date(row.enquiry.tryal_date) : null;
                if (trial_end != null) trial_end.setDate(trial_end.getDate() + row.enquiry.tryal_period);
                return (
                    <div className="card shadow-sm border border-light rounded-3 mb-3 w-100">
                        <div className="card-body p-3">
                            {/* Card Header: Avatar, School Name, Preferred Service and Trial Badge */}
                            <div className="d-flex align-items-start justify-content-between mb-2">
                                <div className="d-flex align-items-center">
                                    <ViewFollowModal follow={row}>
                                        <div style={{ cursor: 'pointer' }}>
                                            <img 
                                                className="me-2 rounded-circle border" 
                                                style={{ width: "42px", height: "42px", objectFit: 'cover' }} 
                                                src={imageUrl} 
                                                alt="User Avatar" 
                                            />
                                        </div>
                                    </ViewFollowModal>
                                    <div>
                                        <h6 className="fs-14 mb-0 fw-semibold">
                                            <ViewFollowModal follow={row}>
                                                <span className="text-primary link-primary" style={{ cursor: 'pointer' }}>{row.enquiry.name}</span>
                                            </ViewFollowModal>
                                        </h6>
                                        <div className="d-flex flex-wrap gap-1 mt-1 align-items-center">
                                            {row.enquiry?.course?.code && (
                                                <span className="badge bg-soft-info text-info fs-10 px-2 py-0.5">
                                                    Applied for: {row.enquiry.course.code}
                                                </span>
                                            )}
                                            {trial_end != null && (
                                                trial_end > Date.now()
                                                    ? (<span className='badge badge-soft-success fs-10 px-2 py-0.5'>On Trail</span>)
                                                    : (<span className='badge badge-soft-danger fs-10 px-2 py-0.5'>Trail Expired</span>)
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <span className="badge badge-soft-warning px-2 py-1 fs-10 text-capitalize">
                                    {row.status}
                                </span>
                            </div>

                            {/* Details Row: Phone, Next Date, and SMS/FollowUp History */}
                            <div className="py-2 border-top border-bottom border-light my-2">
                                <div className="row g-2">
                                    <div className="col-6">
                                        <small className="text-muted d-block fs-11">Phone</small>
                                        <a href={`tel:${row.enquiry.phone}`} className="text-success fs-12 fw-semibold d-inline-flex align-items-center">
                                            <i className="bx bx-phone me-1 fs-14" />
                                            {row.enquiry.phone}
                                        </a>
                                    </div>
                                    <div className="col-6">
                                        <small className="text-muted d-block fs-11">Next Follow Up</small>
                                        <span className="text-dark fs-12 fw-medium d-inline-flex align-items-center">
                                            <i className="ri-calendar-event-line me-1 fs-12 text-muted" />
                                            {formatDate(row.joining_date)}
                                        </span>
                                    </div>
                                    <div className="col-6 d-flex align-items-end justify-content-start">
                                        <FollowUpHistoryModal enquiryId={row.enquiry.id} schoolName={row.enquiry.name}>
                                            <span className="btn btn-sm btn-soft-primary px-2 py-0.5 fs-11 d-inline-flex align-items-center gap-1">
                                                <i className="ri-chat-3-line fs-12" />
                                                <span>SMS History</span>
                                            </span>
                                        </FollowUpHistoryModal>
                                    </div>
                                </div>
                            </div>

                            {/* Actions Footer */}
                            <div className="d-flex align-items-center justify-content-between pt-1">
                                <div>
                                    <ViewFollowModal follow={row} />
                                </div>
                                <div>
                                    {(isDate1BeforeOrEqual(formattedDate, row.joining_date)) 
                                        ? <FollowUpBtn follow={row} /> 
                                        : <span className='badge badge-soft-warning px-2 py-1 fs-11'>Postponed</span>}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        }

    ], [followups]);
    return (
        <>
            <BreadCrumb title="Follow UP" prevPage="Home" prevPath="/dashboard" />
            <Row>
                <Col xs={12}>
                    <Card>
                        <CardHeader className="d-flex align-items-center justify-content-between">
                            <h5 className="card-title mb-0">Follow Up List</h5>
                        </CardHeader>
                        <CardBody className="">
                            <TableResponsive isLoading={isLoading} columns={columns} data={followups} noRecord="No Record Follow List" />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    )
}


export default FollowUp;
